<script setup lang="ts">
import { toHead } from 'vue-datocms'
import { queryPage } from '~/graphql/queries/page'
import type { StringMultiLocaleField, BooleanTypeNonNullMultiLocaleField } from '~/types/datocms'
import { ApiErrorType } from '~/types'

const { throwError, handleApiError } = useApiError()
const { resolveSectionComponent } = useResolveComponent()

const { locale } = useI18n()
const route = useRoute()

const { data, error } = await useDatoQuery(queryPage, {
  variables: {
    locale: locale.value,
    slug: route.params.slug
  }
})

if (error.value) {
  handleApiError(error.value)
}

if (!data.value?.page) {
  throwError(ApiErrorType.NOT_FOUND)
}

// Dynamic route parameters
const setI18nParams = useSetI18nParams()
const publishedLocales = useLocaleSlugs(
  data.value?.page?._allSlugLocales as StringMultiLocaleField[],
  data.value?.page?._allPublishTranslationLocales as BooleanTypeNonNullMultiLocaleField[]
)
setI18nParams(publishedLocales)

if (data.value?.page?.seoMetadata?.noIndex || !data.value?.page?.publishTranslation) {
  useRobotsRule('noindex, nofollow')
}

// DatoCMS injects the noIndex field in the SEO metatags when present which overrides the useRobotsRule.
useHead(() => {
  return toHead(data.value?.page?._seoMetaTags || [])
})
</script>

<template>
  <div v-if="data?.page">
    <component
      :is="resolveSectionComponent(item.__typename as SectionComponents)"
      v-for="(item, index) in data.page?.main"
      :key="item.id"
      :data="item"
      :module-index="index"
    />
  </div>
</template>
